<template>
  <div>
    <div class="portfolio-component mini-spacer">
      <v-container>
        <!-- -----------------------------------------------
            Start Portfolio
        ----------------------------------------------- -->
        <v-row class="mt-13">
          <v-col cols="12" md="6" lg="4">
            <v-card class="portfolio-card overflow-hidden">
              <div style="overflow: hidden;
    				max-height: 300px; max-width: 400px;" class="portfolio-img">
                <img
                  src="@/assets/images/portfolio/1.jpg"
                  class="img-fluid"
                  alt="portfolio"
                />
              </div>
              <v-card-text>
                <h5 class="font-weight-medium font-18">
                  Todo lo que necesitas para la preparación y control
                </h5>
                <p class="font-14 mb-0">Restaurantes</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-card class="portfolio-card overflow-hidden">
              <div style="overflow: hidden;
    				max-height: 300px; max-width: 400px;" class="portfolio-img">
                <img
                  src="@/assets/images/portfolio/2.jpg"
                  class="img-fluid"
				  style="img {
					transition: 0.1s ease-in;
					cursor: pointer;
					}

					&:hover {
					img {
						transform: scale(1.1);
					}
					}"
                  alt="portfolio"
                />
              </div>
              <v-card-text>
                <h5 class="font-weight-medium font-18">Control de producción y mermas</h5>
                <p class="font-14 mb-0">Panaderías</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-card>
              <div style="overflow: hidden;
    				max-height: 300px; max-width: 400px;">
                <img
                  src="@/assets/images/portfolio/4.jpg"
                />
              </div>
              <v-card-text>
                <h5 class="font-weight-medium font-18">Controla Inventarios, proformas y mucho más</h5>
                <p class="font-14 mb-0">Ferreterías</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-card class="portfolio-card overflow-hidden">
              <div style="overflow: hidden;
    				max-height: 300px; max-width: 400px;" >
                <img
                  src="@/assets/images/portfolio/5.jpg"
                />
              </div>
              <v-card-text>
                <h5 class="font-weight-medium font-18">Sincroniza tu tienda en linea con tu POS</h5>
                <p class="font-14 mb-0">E-Commerce</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-card class="portfolio-card overflow-hidden">
              <div style="overflow: hidden;
    				max-height: 300px; max-width: 400px;" class="portfolio-img">
                <img
                  src="@/assets/images/portfolio/3.jpg"
                  class="img-fluid"
                  alt="portfolio"
                />
              </div>
              <v-card-text>
                <h5 class="font-weight-medium font-18">Control estricto de inventario y usuarios</h5>
                <p class="font-14 mb-0">Retai</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-card class="portfolio-card overflow-hidden">
              <div style="overflow: hidden;
    				max-height: 300px; max-width: 400px;" class="portfolio-img">
                <img
                  src="@/assets/images/portfolio/1.jpg"
                 
                  alt="portfolio"
                />
              </div>
              <v-card-text>
                <h5 class="font-weight-medium font-18">Sincronizamos todas tus Otas</h5>
                <p class="font-14 mb-0">Hoteles</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- -----------------------------------------------
            End Portfolio
        ----------------------------------------------- -->
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "Portfolio",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
	.portfolio-card {
  .portfolio-img {
    overflow: hidden;
    max-height: 255px;
    img {
      transition: 0.1s ease-in;
      cursor: pointer;
    }

    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
}
</style>

